<script lang="ts">
    import {_} from "svelte-i18n";
    import ButtonZone from "./ButtonZone.svelte";
    import ButtonRoundAccept from "../../shared/ButtonRoundAccept.svelte";
    export let saved: boolean = true;
</script>

{#if false}
    <ButtonZone text={$_('finish_edit_zone')} bind:saved on:click _class="lock" />
{:else}
    <ButtonRoundAccept on:click title={$_('finish_edit_zone')} />
{/if}

